import { Injectable } from '@angular/core';
import { environment } from 'apps/tripointe-cms/src/environments/environment';
import pkceChallenge from 'pkce-challenge';

@Injectable({ providedIn: 'root' })
export class SsoService {
  constructor() {}

  private generateState(): string {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
      /* tslint:disable:no-bitwise */
      const r = (Math.random() * 16) | 0,
        v = c === 'x' ? r : (r & 0x3) | 0x8;
      /* tslint:enable:no-bitwise */

      return v.toString(16);
    });
  }

  async generateAuthUrlSaveState(): Promise<string> {
    const { code_challenge, code_verifier } = await pkceChallenge();
    const state = this.generateState();

    const client_id = environment.azureSso.clientId;
    const scope = `api://${client_id}/${environment.azureSso.scope} offline_access email openid profile https://graph.microsoft.com/User.Read.All`;
    const tenant = environment.azureSso.tenantId;

    sessionStorage.setItem('oauth_state', JSON.stringify({ code_verifier, state }));

    const authUrl = `https://login.microsoftonline.com/${tenant}/oauth2/v2.0/authorize?
                     client_id=${client_id}
                     &response_type=code
                     &redirect_uri=${encodeURIComponent(environment.azureSso.redirectUri)}
                     &response_mode=query
                     &scope=${encodeURIComponent(scope)}
                     &state=${state}
                     &code_challenge=${code_challenge}
                     &code_challenge_method=S256`;

    return authUrl.replace(/\s*/g, '');
  }

  popState(): { code_verifier: string; state: string; redirect_uri: string } {
    const oauth_state = JSON.parse(sessionStorage.getItem('oauth_state'));
    sessionStorage.removeItem('oauth_state');
    const redirect_uri = environment.azureSso.redirectUri;

    return { ...oauth_state, redirect_uri };
  }
}
